import { doc, getDoc } from "firebase/firestore";
import { databasePromise } from "configuration";

const API_BASE = process.env.REACT_APP_API_URL;

export const rateLimitService = {
  async updateRateLimit(action) {
    try {
      const res = await fetch(`${API_BASE}/user/rate-limit`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action }),
      });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        console.error("Error updating rate limit:", body.error);
      }
    } catch (error) {
      console.error("Error updating rate limit:", error);
    }
  },

    async getRateLimit(userId) {
    try {
      const db = await databasePromise;
      const docSnap = await getDoc(doc(db, "users", userId));
      if (docSnap.exists()) {
        return docSnap.data().rateLimits || null;
      }
      return null;
    } catch (error) {
      console.error("Error fetching rate limit:", error);
      return null;
    }
  },
};
